import Vue from 'vue';
import {
  SET_MEDIAS,
  SET_MEDIAS_ERROR,
  SET_MEDIA_ERROR,
  SET_MEDIA_LOADING,
  SET_UPLOADED_MEDIAS,
  SET_MEDIA_PREVIEW,
  SET_MEDIA_UPDATE,
  SET_MEDIA_UPLOAD,
  SET_MEDIA_NAME_INVALID,
  ADD_MEDIA_LABEL_SUGGESTION,
  REMOVE_MEDIA_LABEL_SUGGESTION,
  SET_MEDIA_LIST,
  SET_MEDIAS_LOADING,
} from './mutation-types';

export default {
  /**
   * Media loading state
   * @param state
   * @param loading
   */
  [SET_MEDIAS_LOADING](state, loading) {
    state.mediaLoading = loading;
  },
  /**
   * Set media for a product
   * @param {object} state - the vuex state object
   * @param {string} offerItemId - Id of offer item is attached to
   * @param {array} payload - array of medias
   */
  [SET_MEDIAS](state, {
    offerItemId,
    payload,
  }) {
    if (!state.medias[offerItemId]) {
      Vue.set(state.medias, offerItemId, []);
    }
    state.medias[offerItemId].push(...payload);
  },

  /**
   * Update media in mission's medias array
   * @param {object} state - the vuex state object
   * @param {string} mediaId - the media ID
   * @param {object} updatedMedia - the complete & updated media object
   */
  [SET_MEDIA_UPDATE](state, {
    mediaId,
    updatedMedia,
  }) {
    const medias = Object.values(state.medias);
    const offerIndex = medias.findIndex((arr) => arr.find(({
      id,
    }) => id === mediaId));
    const offerItemId = Object.keys(state.medias)[offerIndex];
    const mediaIndex = state.medias[offerItemId].findIndex(({
      id,
    }) => id === mediaId);
    const mediasOffer = state.medias[offerItemId];
    mediasOffer.splice(mediaIndex, 1, updatedMedia);
  },

  /**
   * Set all uploade media
   * @param {object} state - the vuex state object
   * @param {array} medias - array of medias
   */
  [SET_UPLOADED_MEDIAS](state, medias) {
    state.medias = medias;
  },

  /**
   * Set medias error
   * @param {object} state - the vuex state object
   * @param {object} payload - error object
   */
  [SET_MEDIAS_ERROR](state, err) {
    state.error = err;
  },

  /**
   * Set media error
   * @param {object} state - the vuex state object
   * @param {object} payload - error object
   */
  [SET_MEDIA_ERROR](state, {
    fileId,
    mediaId,
  }) {
    const medias = Object.values(state.medias);
    let mediaError;
    if (fileId) {
      mediaError = medias
        .flat()
        .find((media) => media?.relationships?.files?.data
          .find((file) => file?.id === fileId));
    } else {
      mediaError = medias
        .flat()
        .find((media) => media?.id === mediaId);
    }
    const mediaErrorId = mediaError.id;
    const offerIndex = medias.findIndex((arr) => arr.find(({
      id,
    }) => id === mediaErrorId));
    const offerItemId = Object.keys(state.medias)[offerIndex];
    const mediaIndex = state.medias[offerItemId].findIndex(({
      id,
    }) => id === mediaErrorId);
    Vue.set(state.medias[offerItemId][mediaIndex], 'error', true);
    Vue.set(state.medias[offerItemId][mediaIndex], 'loading', false);
  },

  /**
   * Set media loading
   * @param {object} state - the vuex state object
   * @param {object} payload - error object
   */
  [SET_MEDIA_LOADING](state, {
    mediaId,
    offerItemId,
    progress,
  }) {
    const mediaIndex = state.medias[offerItemId].findIndex((media) => media.id === mediaId);
    Vue.set(state.medias[offerItemId][mediaIndex], 'error', false);
    Vue.set(state.medias[offerItemId][mediaIndex], 'loading', true);
    Vue.set(state.medias[offerItemId][mediaIndex], 'progress', progress);
  },

  /**
   * Set media preview
   * @param {object} state - the vuex state object
   * @param {object} payload - error object
   */
  [SET_MEDIA_PREVIEW](state, {
    offerItemId,
    mediaId,
    previews,
  }) {
    const mediaIndex = state.medias[offerItemId].findIndex((media) => media.id === mediaId);
    Vue.set(state.medias[offerItemId][mediaIndex], 'preview', previews);
  },

  /**
   * Update media in mission's medias array
   * @param {object} state - the vuex state object
   * @param {string} mediaId - the media ID
   * @param {object} updatedMedia - the complete & updated media object
   */
  [SET_MEDIA_UPDATE](state, {
    mediaId,
    updatedMedia,
  }) {
    const medias = Object.values(state.medias);
    const offerIndex = medias.findIndex((arr) => arr.find(({
      id,
    }) => id === mediaId));
    const offerItemId = Object.keys(state.medias)[offerIndex];
    const mediaIndex = state.medias[offerItemId].findIndex(({
      id,
    }) => id === mediaId);
    const mediasOffer = state.medias[offerItemId];
    mediasOffer.splice(mediaIndex, 1, updatedMedia);
  },

  /**
   * update a media status to uploaded
   * @param {object} state - the vuex state object
   * @param {string} mediaFilesId - the mediaFileId of the media To Upload
   */
  [SET_MEDIA_UPLOAD](state, mediaFilesId) {
    const offerIds = Object.keys(state.medias);
    // eslint-disable-next-line max-len
    offerIds.map((offerId) => state.medias[offerId].map((media, index) => {
      const { data } = media.relationships.files;
      data.map((file) => {
        if (file.id === mediaFilesId) {
          Vue.set(state.medias[offerId][index].attributes, 'current_status', 'UPLOADED');
          return true;
        }
        return false;
      });
      return data;
    }));
  },

  /**
   * update mediasWithInvalidName with the mediaId
   * @param {object} state - the vuex state object
   * @param {string} mediaId - the mediaId mark as invalid
   * @param {boolean} unmark - to add or remove the mediaId
   */
  [SET_MEDIA_NAME_INVALID](state, {
    mediaId,
    unmark,
  }) {
    const mediaIndex = state.mediasWithInvalidName.indexOf(mediaId);
    if (!unmark) {
      if (mediaIndex === -1) {
        state.mediasWithInvalidName.push(mediaId);
      }
    } else if (mediaIndex !== -1) {
      state.mediasWithInvalidName.splice(mediaIndex, 1);
    }
  },

  [ADD_MEDIA_LABEL_SUGGESTION](state, { label }) {
    state.suggestions.push(label);
  },

  [REMOVE_MEDIA_LABEL_SUGGESTION](state, { label }) {
    state.suggestions = state.suggestions.filter(({ id }) => id === label.id);
  },

  [SET_MEDIA_LIST](state, list) {
    state.mediaList = list;
  },
};
